import { render, staticRenderFns } from "./addReward.vue?vue&type=template&id=0e70a741&scoped=true"
import script from "./addReward.vue?vue&type=script&lang=js"
export * from "./addReward.vue?vue&type=script&lang=js"
import style0 from "./addReward.vue?vue&type=style&index=0&id=0e70a741&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e70a741",
  null
  
)

export default component.exports